import { render } from "./profile.html?vue&type=template&id=4350eb12&external"
import script from "./profile.js?vue&type=script&lang=js&external"
export * from "./profile.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__